/**
 * HTML escaping for the few places the client builds markup by hand.
 *
 * Today that is one place: the Leaflet popups on the community program
 * layers, which interpolate names and places straight out of a third party
 * GeoJSON export. Everything else in the app renders through React, which
 * escapes for us.
 *
 * Escapes the five characters that matter inside element text and inside
 * double- or single-quoted attribute values. Deliberately a copy of
 * functions/src/utils/html.ts: functions/ is a separate package and cannot
 * be imported from src/. Keep the two in step.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
